import { makeStyles } from '@material-ui/styles';
import WarnIcon from '@material-ui/icons/ReportProblem';
import React from 'react';
import { Typography } from '@material-ui/core';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    alignItems: 'center',
    padding: '1rem',
    backgroundColor: 'rgba(255, 207, 0, 0.35)',
    borderRadius: '0.5rem',
    width: '100%ß'
  },
  text: {
    fontSize: '0.875rem',
    marginLeft: '2rem',
    fontWeight: 500,
    color: '#171717'
  },
  icon: {
    fill: '#ea8f08'
  },
  wrapper: {
    padding: '1rem',
    minHeight: '3rem',
    width: '100%'
  }
});

interface InfoBannerProps {
  text: string;
}

const InfoBanner = ({ text }: InfoBannerProps) => {
  const classes = useStyles();

  return (
    <div className={classes.wrapper}>
      <div className={classes.container}>
        <WarnIcon className={classes.icon} />
        <Typography className={classes.text}>{text}</Typography>
      </div>
    </div>
  );
};

export default InfoBanner;
